export enum UserHeaders {
  Hash = "hash",
  Platform = "platform",
}

export const localUserIdPrefix = "USER_ID=";
